import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import Aos from "aos";
import "aos/dist/aos.css";
import OurPricingData from "./OurPricingData";

export default function DiventaCliente() {
  // const [pricingdata, setpricingdata] = useState(OurPricingData);
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <>
      <div className="spacing" id="diventacliente">
        <div className="peopleSayBgColor">
          <div className="container">
            <div className="titleFont text-center" data-aos="zoom-out">
              <h2>3 SEMPLICI PASSAGGI PER ACQUISTARE DA NOI</h2>
            </div>
            <div className="ourPricingCard">
              <Row>
                {OurPricingData.map((pricing) => (
                  <Col xl={4} lg={4} md={4} sm={4} xs={12} key={pricing.id} id={pricing.id}>
                    <div className="pricingCard" data-aos="flip-left">
                      <div className="pricingColorBox text-center">
                        <h3>
                          <i className={pricing.logo}></i>
                        </h3>
                        <h2>{pricing.title}</h2>
                      </div>
                      <div className="pricingSpacingBox text-center">
                        <div className="list-unstyled pricingBoxList">
                          <span> {pricing.contain} </span>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
            <div className="text-center mt-5" data-aos="zoom-out">
              <button className="button">
                <a href="https://shop.italycashpuglia.it/pdf/ScaricaModuloDiRegistrazione.pdf" target="_blank" rel="noopener noreferrer"> SCARICA IL MODULO </a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
